export default __webpack_public_path__ + "static/media/end_late_beach.a4048cf9.jpg";